<div class="modal-header">
  <h4 class="modal-title">{{'changeBaseArticle.title' | translate }}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">

    <p>{{ 'changeBaseArticle.prompt' | translate : {'0': currentBaseArticleNo} }}</p>

    <div class="mb-3 row">
      <label class="col-md-4 col-form-label">{{'changeBaseArticle.label.article_number' | translate}}: </label>
      <div class="col-md-8">
        <input type="text"
               spellcheck="false"
               class="form-control"
               id="articleNoInput"
               #articleNoInput
               [(ngModel)]="inputValue"
               (ngModelChange)="inputChanged$.next($event)"
               (keydown.enter)="submit()">
      </div>
    </div>


    <div class="article-preview" data-testid="article-preview">
      <div *ngIf="newBaseArticle" class="d-flex gap-3">
        <img class="img" [src]="newBaseArticleImage" onerror="this.src='/assets/productimages/no-image.png'" alt="article preview">
        <div class="d-flex flex-column gap-2">
          <strong>{{newBaseArticle.articleNo}}</strong>

          <ng-container *ngIf="separatedDisplayName(newBaseArticle) as displayNameParts">
            <strong class="small article-text mt-1">{{displayNameParts[0] ?? ''}}</strong>
            <p class="mt-1 mb-1 small article-text">{{(displayNameParts[1] ?? '') | truncate : 120}}</p>
          </ng-container>
        </div>
      </div>
      <i *ngIf="inputValue.length > 0 && !newBaseArticle && !loading" class="invalid-feedback">{{ 'changeBaseArticle.label.no_article_found' | translate : {'0': inputValue } }}</i>
      <i *ngIf="showUnsupportedSeriesHint" class="invalid-feedback">{{ 'changeBaseArticle.label.unsupported_series' | translate }}</i>

    </div>

    <p class="text-secondary">{{ 'changeBaseArticle.description' | translate }}</p>
  </div>
</div>

<div class="modal-footer">
  <button type="button" data-testid="close-button" class="btn btn-secondary btn-cancel" (click)="close()">
    {{'global.label.cancel' | translate}}
  </button>
  <button type="button" data-testid="save-button" class="btn btn-primary btn-forward" [disabled]="!articleNoInput.value.trim() || loading" (click)="submit()">
    {{'global.label.save' | translate}}
  </button>
</div>
